export default __webpack_public_path__ + "static/media/twitter.fe06d572.svg";